import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../common/loader";
import { formateDate } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import Breadcrums from "../../common/breadcrumbs";
import { subscriptionPlanType, DYNAMIC_VARIABLES } from "../../../../utils/Constants";
import { SubscriptionPlanDetails } from "../../services/subscriptionPlan.services";

const SubscriptionPlanView = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const params = useParams();
  const [showdefault, setShowDefault] = useState({});

  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    {
      title: t("Subscription Plan"),
      url: "/admin/subscription/subscription-plan/list/1",
    },
    { title: t("View"), url: "" },
  ];


  useEffect(() => {
    SubscriptionPlanDetails(params.id)
      .then((response) => {
        setShowDefault(response && response.data ? response.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">
                  {t("View Subscription Plan")}
                </h6>
              </div>

              {showdefault && Object.keys(showdefault).length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table  table-bordered table-hover"
                    >
                      <tbody>
                        <tr>
                          <th>{t("Plan name")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.name
                              ? showdefault.name
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Plan Category")}</th>
                          <td className="text-uppercase font-weight-bold">
                            {showdefault && showdefault.plan_category
                              ? showdefault.plan_category
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Plan Type")}</th>
                          <td className="text-uppercase font-weight-bold">
                            {showdefault && showdefault.plan_type
                              ? showdefault.plan_type.replace(/_/g, ' ')
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Plan price")} (INR)</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.price_inr
                              ? showdefault.price_inr
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Plan price")} (USD)</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.price_usd
                              ? showdefault.price_usd
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Duration (Months)")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.duration_months
                              ? showdefault.duration_months
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Android Product ID")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.android_product_id
                              ? showdefault.android_product_id
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("iOS Product ID")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.ios_product_id
                              ? showdefault.ios_product_id
                              : "N/A"}
                          </td>
                        </tr>
                        {/* <tr>
                          <th>{t("Features Included")}</th>
                          <td>
                            {showdefault && showdefault.features && showdefault.features.length > 0 ? (
                              <ul>
                                {showdefault.features.map((feature, i) => (
                                  <li key={i}>{feature}</li>
                                ))}
                              </ul>
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr> */}
                        <tr>
                          <th>{t("Plan Icon")}</th>
                          <td>
                            {showdefault && showdefault.icon ? (
                              <img src={`${DYNAMIC_VARIABLES.SERVER_URL}/public/uploads/subscription/${showdefault.icon}`} alt="Icon" style={{ width: '50px', height: '50px' }} />
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_created_date")}</th>
                          <td>
                            {showdefault && (showdefault.created_at || showdefault.createdAt)
                              ? formateDate(showdefault.created_at || showdefault.createdAt)
                              : "N/A"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <Loader />
              )}
            </div>
            <div className="ml-4 back-button mx-0">
              <button
                className="btn ripple btn-dark"
                type="button"
                onClick={() =>
                  navigate("/admin/subscription/subscription-plan/list/1")
                }
              >
                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                {t("btn_back")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubscriptionPlanView;
